/**
 * Mock API
 * ========
 * API functions for mock data generation (dev/staging only).
 */

import apiClient from './client';

const MOCK_BASE = '/api/v1/mock';

/**
 * Create a full mock lead with research, meeting, transcript, and questionnaire
 */
export const createMockLead = async () => {
  const response = await apiClient.post(`${MOCK_BASE}/create-lead`);
  return response.data;
};

/**
 * Generate a mock AI transcript for an existing meeting
 */
export const generateMockTranscript = async (leadId, meetingId) => {
  const response = await apiClient.post(
    `${MOCK_BASE}/leads/${leadId}/meetings/${meetingId}/mock-transcript`
  );
  return response.data;
};

const mockAPI = {
  createMockLead,
  generateMockTranscript,
};

export default mockAPI;
